module.exports = __webpack_public_path__ + "static/media/access.94297b18.svg";